/* Parkhart Studio theme — cart drawer, quantity, gallery, reveal, header */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // Money formatting from shop setting (e.g. "${{amount}}")
  function money(cents) {
    const fmt = (window.theme && window.theme.moneyFormat) || "${{amount}}";
    const amount = (cents / 100).toFixed(2);
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fmt.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, (m, nd) => (nd ? Math.round(cents / 100).toLocaleString() : withCommas)).replace(/<[^>]+>/g, "");
  }

  // ---------- Header ----------
  const header = $(".header");
  if (header) {
    const onScroll = () => header.classList.toggle("is-scrolled", window.scrollY > 8);
    onScroll(); window.addEventListener("scroll", onScroll, { passive: true });
  }
  const mobileNav = $("#MobileNav");
  $$("[data-menu-open]").forEach((b) => b.addEventListener("click", () => mobileNav && mobileNav.classList.add("is-open")));
  $$("[data-menu-close]").forEach((b) => b.addEventListener("click", () => mobileNav && mobileNav.classList.remove("is-open")));

  // ---------- Scroll reveal ----------
  const reveals = $$(".reveal");
  if ("IntersectionObserver" in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    reveals.forEach((el) => io.observe(el));
  } else reveals.forEach((el) => el.classList.add("is-in"));

  // ---------- Quantity steppers ----------
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-qty-change]");
    if (!btn) return;
    const input = btn.parentElement.querySelector("input");
    const min = Number(input.min || 1);
    const next = Math.max(min, Number(input.value || 1) + Number(btn.dataset.qtyChange));
    input.value = next;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  // ---------- Product gallery ----------
  $$("[data-gallery]").forEach((g) => {
    const main = $("[data-gallery-main]", g);
    $$("[data-gallery-thumb]", g).forEach((t) => t.addEventListener("click", () => {
      $$("[data-gallery-thumb]", g).forEach((x) => x.classList.remove("is-active"));
      t.classList.add("is-active");
      main.src = t.dataset.src; main.srcset = t.dataset.srcset || ""; main.alt = t.dataset.alt || "";
    }));
  });

  // ---------- Cart drawer ----------
  const drawer = $("#CartDrawer");
  const toast = $("#Toast");
  let toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg; toast.classList.add("is-visible");
    clearTimeout(toastTimer); toastTimer = setTimeout(() => toast.classList.remove("is-visible"), 2200);
  }
  function openDrawer() { document.body.classList.add("drawer-open"); drawer && drawer.setAttribute("aria-hidden", "false"); }
  function closeDrawer() { document.body.classList.remove("drawer-open"); drawer && drawer.setAttribute("aria-hidden", "true"); }
  $$("[data-cart-open]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); refreshCart().then(openDrawer); }));
  $$("[data-cart-close]").forEach((b) => b.addEventListener("click", closeDrawer));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeDrawer(); });

  function renderCart(cart) {
    $$("[data-cart-count]").forEach((el) => {
      el.textContent = cart.item_count; el.dataset.count = cart.item_count;
      el.classList.add("is-bumping"); setTimeout(() => el.classList.remove("is-bumping"), 300);
    });
    if (!drawer) return;
    const body = $("[data-drawer-body]", drawer);
    const foot = $("[data-drawer-foot]", drawer);
    if (!cart.items.length) {
      body.innerHTML = `<div class="drawer__empty"><p class="script">Nothing here yet</p><p>${window.theme.strings.empty}.</p><button class="btn btn--ghost" data-cart-close>Keep browsing</button></div>`;
      foot.style.display = "none";
      $$("[data-cart-close]", body).forEach((b) => b.addEventListener("click", closeDrawer));
      return;
    }
    foot.style.display = "";
    body.innerHTML = cart.items.map((it) => `
      <div class="line" data-line-key="${it.key}">
        <a href="${it.url}"><img src="${it.image ? it.image + (it.image.includes("?") ? "&" : "?") + "width=200" : ""}" alt=""></a>
        <div>
          <p class="line__title"><a href="${it.url}">${it.product_title}</a></p>
          ${it.variant_title && it.variant_title !== "Default Title" ? `<p class="line__meta">${it.variant_title}</p>` : ""}
          <div class="qty"><button type="button" data-line-change="-1" aria-label="Decrease">−</button><input type="number" min="0" value="${it.quantity}" data-line-qty aria-label="Quantity"><button type="button" data-line-change="1" aria-label="Increase">+</button></div>
          <button type="button" class="line__remove" data-line-remove>Remove</button>
        </div>
        <div class="line__price">${money(it.final_line_price)}</div>
      </div>`).join("");
    $("[data-cart-total]", drawer).textContent = money(cart.total_price);
  }

  function refreshCart() {
    return fetch(window.theme.routes.cart + ".js", { headers: { Accept: "application/json" } }).then((r) => r.json()).then((c) => { renderCart(c); return c; });
  }

  function changeLine(key, quantity) {
    return fetch(window.theme.routes.cartChange + ".js", {
      method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity }),
    }).then((r) => r.json()).then(renderCart);
  }

  if (drawer) {
    drawer.addEventListener("click", (e) => {
      const line = e.target.closest("[data-line-key]"); if (!line) return;
      const key = line.dataset.lineKey;
      const input = $("[data-line-qty]", line);
      if (e.target.closest("[data-line-change]")) {
        const q = Math.max(0, Number(input.value) + Number(e.target.closest("[data-line-change]").dataset.lineChange));
        changeLine(key, q);
      } else if (e.target.closest("[data-line-remove]")) changeLine(key, 0);
    });
    drawer.addEventListener("change", (e) => {
      const line = e.target.closest("[data-line-key]");
      if (line && e.target.matches("[data-line-qty]")) changeLine(line.dataset.lineKey, Math.max(0, Number(e.target.value)));
    });
  }

  // Add-to-cart forms (product page + quick add on cards)
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (!form.matches("[data-product-form]")) return;
    e.preventDefault();
    const btn = $("[type=submit]", form);
    const original = btn.textContent;
    btn.disabled = true; btn.textContent = "Adding…";
    const fd = new FormData(form);
    fetch(window.theme.routes.cartAdd + ".js", { method: "POST", body: fd, headers: { Accept: "application/json" } })
      .then((r) => r.json())
      .then((res) => {
        if (res.status && res.status >= 400) throw new Error(res.description || "Could not add");
        return refreshCart();
      })
      .then(() => { showToast(window.theme.strings.added); openDrawer(); })
      .catch((err) => showToast(err.message))
      .finally(() => { btn.disabled = false; btn.textContent = original; });
  });

  // Initial count
  refreshCart().catch(() => {});
})();
